// extracted by mini-css-extract-plugin
export var modal = "_4l-0";